module.exports = __webpack_public_path__ + "static/media/vermi_soil_struct.e7f0b190.png";